import styled from 'styled-components';
import Slider from 'react-slick';

import theme from '../../styles/theme';

export const Container = styled.div`
  height: 550px;
  background-color: ${theme.faqBrackground};
  display: none;

  @media (max-width: 860px) {
    display: block;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  height: 400px;
`;

export const TimelineDot = styled.div`
  display: flex;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  z-index: 2;
  justify-content: center;
  align-items: center;
  font-size: 60px;
  height: 80px;
  width: 80px;
  border-radius: 100%;
  border: 10px solid ${theme.primaryDarker};
  background-color: ${theme.primary};
`;

export const Card = styled.div`
  display: flex;
  justify-self: flex-end;
  justify-content: center;
  flex-direction: column;
  margin-top: 170px;
  background-color: ${theme.background};
  border-radius: 30px;
  min-height: 210px;
  height: 210px;
`;

export const Text = styled.p`
  color: ${theme.accent};
  font-size: 20px;
  text-align: center;
  margin: 30px;
`;

export const Link = styled.a`
  color: ${theme.accent};
  font-size: 20px;
  text-align: center;
  margin: 30px;
  text-decoration: none;
`;

export const LinkHighlight = styled.b`
  font-weight: bold;
  color: ${theme.primary};
`;

export const CustomSlider = styled(Slider)`
  display: flex;
  min-width: 100%;
  padding: 20px;
`;

export const VerticalLine = styled.div`
  border-left: 2px solid ${theme.background};
  height: 35px;
  position: absolute;
  left: 50%;
  margin-left: -1px;
  top: 130px;
  transform: translateY(-50%);
`;
